import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchSpot } from '../../store/slices/savedSpotsSlice'
import ForecastDataTable from '../../components/open-meteo/hourly/ForecastDataTable'
import Header from '../../layout/Header'
import MobileNav from '../../layout/MobileNav'
import { fetchForecastDataByLocation } from '../../store/slices/forecastSlice';
import { fetchSpotHourlyForecastData } from '../../store/slices/hourlyForecastSlice';
import PageNavSavedLocation from '../../layout/PageNavSavedLocation';
import PageNavLocation from '../../layout/PageNavLocation';
import Loader from '../../components/common/Loader';
import {Helmet} from "react-helmet";

const SpotForecast = () => {
    const [location, setLocation] = React.useState(null);
    const { id } = useParams();
    
    // Update to use savedSpots slice and access spot by ID
    const { spots } = useSelector(state => state.savedSpots);
    const hourlySpots = useSelector(state => state.hourlyForecast.spots);
    const isLoadingHourlyForecast = useSelector(state => state.hourlyForecast.isLoading);
    const isLoadingForecast = useSelector(state => state.forecast.isLoading);
    const { forecastData } = useSelector(state => state.forecast);
    const currentSpot = id ? spots[id] : null;
    const HourlyForecast = id ? hourlySpots[id] : null;
    const visibleUnits = useSelector((state) => state.hourlyForecast.visibleUnitsHourly) || {
        wave_height_max: true,
        wave_direction_dominant: false,
        wave_period_max: false,
        wind_speed_10m_max: false,
        wind_direction_10m_dominant: false,
        overall_rating_score: true
    };

    const includedHours = useSelector((state) => state.hourlyForecast.includedHours) || [
        '03:00', '06:00', '09:00', '12:00', '14:00', '16:00', '18:00', '20:00'
    ];
   
    const dispatch = useDispatch();

    React.useEffect(() => {
        if(id && id !== 'undefined') {
            dispatch(fetchSpot(id));
            dispatch(fetchSpotHourlyForecastData(id));
        }
    }, [dispatch, id]);

    React.useEffect(() => {
        if(id && id !== 'undefined') return;
        const params = new URLSearchParams(window.location.search);
        const lat = params.get('lat');
        const lon = params.get('lon');
        if(lat && lon) {
            dispatch(fetchForecastDataByLocation({ lat, lon }));
        }
        setLocation({ lat, lon });
    }, [dispatch, id]);

    const renderForecast = () => {

        if(location){

            if(isLoadingForecast){
                return (
                    <div className='mt-10'>
                        <Loader size="md" text="Fetching forecast..." />
                    </div>
                )
            }

            if(!forecastData){
                return <p className='mt-10 mb-10'>Not Found Forecast Data.</p>
            }

            return <ForecastDataTable forecastData={forecastData} visibleUnits={visibleUnits} includedHours={includedHours} />
        }

        if(isLoadingHourlyForecast && !HourlyForecast){
            return (
                <div className='mt-10'>
                    <Loader size="md" text="Fetching hourly forecast..." />
                </div>
            )
        }

        if(!HourlyForecast){
            return (
                <div className='mt-10'>
                    <p className='text-white/70'>No Hourly Forecast Data Found.</p>
                </div>
            )
        }

        return <ForecastDataTable forecastData={HourlyForecast} currentSpot={currentSpot} visibleUnits={visibleUnits} includedHours={includedHours} />
    }

    return (
        <>
            <Helmet>
                <title>{currentSpot?.name ? currentSpot.name : "Current Spot"} Forecast | Oreca Pro</title>
                <link rel="canonical" href={window.location.href} />
            </Helmet>
            <Header />
            <MobileNav />
            <div className='py-[80px] px-5 max-w-[1100px] mx-auto'>

                <h1 className='text-2xl font-semibold mb-2 md:mt-8'>
                    {currentSpot?.name ? currentSpot.name : "Current Spot"}
                </h1>

                <p className='text-xs text-custom-light-grey'>
                    {currentSpot ? `${Number(currentSpot.latitude).toFixed(2)}, ${Number(currentSpot.longitude).toFixed(2)}` : location ? `${Number(location.lat).toFixed(2)}, ${Number(location.lon).toFixed(2)}` : ''}
                </p>

                {/* <p>{isLoadingHourlySpots ? 'Loading...' : ''}</p> */}

                {/* page nav */}
                {id ? 
                <PageNavSavedLocation id={currentSpot?.id} /> 
                : 
                <PageNavLocation location={location} />}

                {/* save spot */}
                <div id="view-spot">
                    {renderForecast()}
                </div>
            </div>
        </>
    )
}

export default SpotForecast
